import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {CommonUtils} from "../utils/common";
import {Observable} from "rxjs";
import {VetineoApiResponse} from "../models/vetineo-api-response.model";
import {map, take} from "rxjs/operators";
import {GenericHtmlPage} from "../models/generic-html-page.model";

@Injectable({
  providedIn: 'root'
})
export class GenericHtmlPageService {

  constructor(private apiService: ApiService, public commonUtils: CommonUtils) {
  }


  getPageByType(pageType: string): Observable<GenericHtmlPage> {
    return this.apiService.get<VetineoApiResponse>(`/dashboard/tmpl/${pageType}`).pipe(take(1), map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        return this.commonUtils.bestTypedCopyEver(new GenericHtmlPage(), vetineoApiResponse.response);
      } else {
        return undefined;
      }
    }));
  }


  updatePage(pageType: string, genericHtmlPage: GenericHtmlPage): Observable<GenericHtmlPage> {
    return this.apiService.put<VetineoApiResponse>(`/dashboard/tmpl/${pageType}`, genericHtmlPage).pipe(take(1), map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        return this.commonUtils.bestTypedCopyEver(new GenericHtmlPage(), vetineoApiResponse.response);
      } else {
        return undefined;
      }
    }));
  }

}


